import { ActionContext } from 'vuex'
import apiGlider from '@/api/glider'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IGliderState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloDbGlider } from '@/models/alodb/AloDbGlider'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { router } from '@/mainjs.js'
import { IrisrawModNextSurfacingDo } from '@/models/iris/IrisrawModNextSurfacingDo'
import { IrisrawModSingleWayPoint } from '@/models/iris/IrisrawModSingleWayPoint'
import { IrisrawModFileTransfer } from '@/models/iris/IrisrawModFileTransfer'
import { IrisrawModExpectedNMEA } from '@/models/iris/IrisrawModExpectedNMEA'
import { WobGliderModConf } from '@/models/wob/WobGliderModConf'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { IExpectedNMEAConfig } from '@/models/iris/expectedNMEA/IExpectedNMEAConfig'
import { ISingleWayPointConfig } from '@/models/iris/singleWayPoint/ISingleWayPointConfig'
import { INextSurfacingDoConfig } from '@/models/iris/nextSurfacing/INextSurfacingDoConfig'
import { IFileTransfertConfig } from '@/models/iris/fileTransfert/IFileTransfertConfig'
import { WobAdminChanged } from '@/models/wob/WobAdminChanged'
import { GliderModuleApiId, MODULE_API_ID_TO_WIRE_KEY } from '@/models/iris/gliderState/IGliderRuntime'

/**
 * Helper local — dispatch GLIDER_RUNTIME_PATCH_MODULE_ENABLE après chaque
 * fetch/update IRIS module config dans le store glider. Centralise la
 * traduction wire→domain.
 */
function patchRuntimeModuleEnable(
  context: ActionContext<IGliderState, IRootState>,
  moduleKey: GliderModuleApiId,
  irisConfig: unknown,
  gliId: number | null | undefined,
) {
  if (!irisConfig || gliId == null) return
  const wireKey = MODULE_API_ID_TO_WIRE_KEY[moduleKey]
  const enabledMod = (irisConfig as { mod_settings?: { EnabledMOD?: Record<string, unknown> } })?.mod_settings
    ?.EnabledMOD
  const enable = enabledMod?.[wireKey]
  if (typeof enable === 'boolean') {
    context.dispatch(types.GLIDER_RUNTIME_PATCH_MODULE_ENABLE, { gliId, moduleKey, enable })
  }
}
import { ISendMailConfig } from '@/models/iris/sendMail/ISendMailConfig'
import { IMissionPlanConfig } from '@/models/iris/missionPlanConfig/IMissionPlanConfig'
import { IQuickControlConfig } from '@/models/iris/quickControlConfig/IQuickControlConfig'
import { IAisConfig } from '@/models/iris/ais/IAisConfig'
import { IrisrawGliderState } from '@/models/iris/IrisrawGliderState'
import { IAd2cpConfig } from '@/models/iris/ad2cp/IAd2cpConfig'
import { AloMission } from '@/models/alo/AloMission'
import { IrisrawModFtp } from '@/models/iris/IrisrawModFtp'
import { IFtpConfig } from '@/models/iris/ftp/IFtpConfig'
import { IrisrawModRsync } from '@/models/iris/IrisrawModRsync'
import { IRsyncConfig } from '@/models/iris/rsync/IRsyncConfig'
import { ICoriolisConfig } from '@/models/iris/coriolis/ICoriolisConfig'
import { i18n } from '@/locale/vueI18n'

export class GliderAction {
  public [types.GLIDER_SEND_IRIS_COMMAND_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    { gliId, command }: { gliId: number; command: string },
  ) {
    return new Promise((resolve, reject) => {
      //context.commit(types.GLIDER_SEND_IRIS_COMMAND_REQUEST)
      apiGlider
        .postIrisCommand({ gliId, command })
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //const data = resp.data.data // as AloBaseArray<AloDbGlider>
            //context.commit(types.GLIDER_SEND_IRIS_COMMAND_SUCCESS, data)
            //resolve(gliderArray.items)
            resolve({ gliId, command })
          } else {
            //context.commit(types.GLIDER_SEND_IRIS_COMMAND_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          //context.commit(types.GLIDER_SEND_IRIS_COMMAND_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_REQUEST](context: ActionContext<IGliderState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_REQUEST)
      apiGlider
        .getGliders()
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const gliderArray = resp.data.data as AloBaseArray<AloDbGlider>
            context.commit(types.GLIDER_SUCCESS, gliderArray.items)
            resolve(gliderArray.items)
          } else {
            context.commit(types.GLIDER_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_ENSURE_LIST](context: ActionContext<IGliderState, IRootState>) {
    if (context.state.gliders.length == 0) {
      return context.dispatch(types.GLIDER_REQUEST)
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.state.gliders)
      })
    }
  }

  public [types.GLIDER_SELECT_DETAIL](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      const glider = context.getters.glidersById[itemId] as AloDbGlider
      if (glider) {
        if (glider.detailLoaded) {
          context.commit(types.GLIDER_SELECT_DETAIL, glider)
          resolve(glider)
        } else {
          context.dispatch(types.GLIDER_SELECT_DETAIL_REQUEST, itemId).then(gl => {
            context.commit(types.GLIDER_SELECT_DETAIL, gl)
            resolve(gl)
          })
        }
      } else {
        const newGlider = new AloDbGlider()
        context.commit(types.GLIDER_SELECT_DETAIL, newGlider)
        resolve(newGlider)
      }
    })
  }

  public [types.GLIDER_SELECT_DETAIL_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_SELECT_DETAIL_REQUEST, itemId)
      apiGlider
        .getGlider(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const glider = resp.data.data as AloDbGlider
            context.commit(types.GLIDER_SELECT_DETAIL_SUCCESS, glider)
            resolve(glider)
          } else {
            context.commit(types.GLIDER_SELECT_DETAIL_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(() => {
          context.commit(types.GLIDER_SELECT_DETAIL_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_SAVE_REQUEST](context: ActionContext<IGliderState, IRootState>) {
    return new Promise((resolve, reject) => {
      const tryRedirect = !context.state.modifiedAdmGlider.id
      context.commit(types.ENSEIGNE_SAVE_REQUEST, context.state.modifiedAdmGlider.GLI_LIBELLE)
      apiGlider
        .saveGlider(context.state.modifiedAdmGlider)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const glider = resp.data.data as AloDbGlider
            context.commit(types.GLIDER_SELECT_DETAIL_SUCCESS, glider)
            context.commit(types.GLIDER_SELECT_DETAIL, glider)
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.SaveOk', { item: glider.GLI_LIBELLE }))
            if (tryRedirect && router.app.$route.name === 'NewGlider')
              router.push({ name: 'EditGlider', params: { gliderid: glider.GLI_ID!.toString() } })
            resolve(glider)
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.GLIDER_SAVE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.GLIDER_SAVE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.GLIDER_DELETE_REQUEST](context: ActionContext<IGliderState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      const gliId = context.state.originalAdmGlider.GLI_ID!
      const gliLibelle = context.state.originalAdmGlider.GLI_LIBELLE
      context.commit(types.GLIDER_DELETE_REQUEST, gliLibelle)
      apiGlider
        .deleteGlider(gliId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context.commit(types.GLIDER_DELETE_SUCCESS, gliId)
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.DeleteOk', { item: gliLibelle }))
            if (router.app.$route.name === 'EditGlider' && context.state.originalAdmGlider.GLI_ID! == gliId) {
              router.push({ name: 'NewGlider' })
            }
            resolve()
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.GLIDER_DELETE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.GLIDER_DELETE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.GLIDER_EXTERNAL_UPDATE](
    context: ActionContext<IGliderState, IRootState>,
    wob: WobAdminChanged<AloDbGlider>,
  ) {
    return new Promise<void>((resolve, reject) => {
      if (wob.actionType == 'Deleted') {
        //context.dispatch(types.MISSION_GLIDER_DELETE, wob.oldAloDbItem.GLI_ID)
      }
      context.commit(types.GLIDER_EXTERNAL_UPDATE, wob)
      resolve()
    })
  }

  public [types.GLIDER_UPDATE_MODIFIED_ADM](context: ActionContext<IGliderState, IRootState>, newProperties: Object) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_UPDATE_MODIFIED_ADM, newProperties)
      resolve(context.state.modifiedAdmGlider)
    })
  }

  public [types.GLIDER_CANCEL_MODIFIED_ADM](context: ActionContext<IGliderState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_SELECT_DETAIL, context.state.originalAdmGlider)
      resolve(context.state.modifiedAdmGlider)
    })
  }

  public [types.GLIDER_UPDATE_FILTER_ADM](context: ActionContext<IGliderState, IRootState>, newProperties: Object) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_UPDATE_FILTER_ADM, newProperties)
      resolve(context.state.adminFilter)
    })
  }

  public [types.GLIDER_IRIS_NSD_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_NSD_REQUEST)
      apiGlider
        .getNsdConfig(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModNextSurfacingDo
            //@ts-ignore
            if (irisConfig.data.mod_settings.NextSurfacingDo_all.listAction == '')
              irisConfig.data.mod_settings.NextSurfacingDo_all.listAction = []
            //@ts-ignore
            if (typeof irisConfig.data.mod_settings.NextSurfacingDo_all.listAction === 'string')
              irisConfig.data.mod_settings.NextSurfacingDo_all.listAction = [
                irisConfig.data.mod_settings.NextSurfacingDo_all.listAction,
              ]
            //@ts-ignore
            if (irisConfig.data.mod_settings.NextSurfacingDo_next.listAction == '')
              irisConfig.data.mod_settings.NextSurfacingDo_next.listAction = []
            //@ts-ignore
            if (typeof irisConfig.data.mod_settings.NextSurfacingDo_next.listAction === 'string')
              irisConfig.data.mod_settings.NextSurfacingDo_next.listAction = [
                irisConfig.data.mod_settings.NextSurfacingDo_next.listAction,
              ]
            context.commit(types.GLIDER_IRIS_NSD_SUCCESS, { id: itemId, nsdConfig: irisConfig.data })
            patchRuntimeModuleEnable(context, 'NextSurfacingDo', irisConfig.data, itemId)
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_NSD_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_NSD_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_UPDATE_MODIFIED_NSD](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, newProperties }: { itemId: number; newProperties: Object },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_UPDATE_MODIFIED_NSD, { itemId, newProperties })
      resolve(context.state.modifiedNsdConfigs[itemId])
    })
  }

  public [types.GLIDER_CANCEL_MODIFIED_NSD](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_CANCEL_MODIFIED_NSD, itemId)
      resolve(context.state.modifiedNsdConfigs[itemId])
    })
  }

  public [types.GLIDER_IRIS_NSD_SAVE_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_NSD_SAVE_REQUEST)
      apiGlider
        .saveNsdConfig(itemId, context.state.modifiedNsdConfigs[itemId])
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModNextSurfacingDo
            //@ts-ignore
            if (irisConfig.data.mod_settings.NextSurfacingDo_all.listAction == '')
              irisConfig.data.mod_settings.NextSurfacingDo_all.listAction = []
            //@ts-ignore
            if (typeof irisConfig.data.mod_settings.NextSurfacingDo_all.listAction === 'string')
              irisConfig.data.mod_settings.NextSurfacingDo_all.listAction = [
                irisConfig.data.mod_settings.NextSurfacingDo_all.listAction,
              ]
            //@ts-ignore
            if (irisConfig.data.mod_settings.NextSurfacingDo_next.listAction == '')
              irisConfig.data.mod_settings.NextSurfacingDo_next.listAction = []
            //@ts-ignore
            if (typeof irisConfig.data.mod_settings.NextSurfacingDo_next.listAction === 'string')
              irisConfig.data.mod_settings.NextSurfacingDo_next.listAction = [
                irisConfig.data.mod_settings.NextSurfacingDo_next.listAction,
              ]

            context.commit(types.GLIDER_IRIS_NSD_SAVE_SUCCESS, { id: itemId, nsdConfig: irisConfig.data })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_NSD_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_NSD_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_NSD_ENABLE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, enable }: { itemId: number; enable: boolean },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_NSD_SAVE_REQUEST)
      apiGlider
        .enableNsdModule(itemId, enable)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModNextSurfacingDo
            //@ts-ignore
            if (irisConfig.data.mod_settings.NextSurfacingDo_all.listAction == '')
              irisConfig.data.mod_settings.NextSurfacingDo_all.listAction = []
            //@ts-ignore
            if (typeof irisConfig.data.mod_settings.NextSurfacingDo_all.listAction === 'string')
              irisConfig.data.mod_settings.NextSurfacingDo_all.listAction = [
                irisConfig.data.mod_settings.NextSurfacingDo_all.listAction,
              ]
            //@ts-ignore
            if (irisConfig.data.mod_settings.NextSurfacingDo_next.listAction == '')
              irisConfig.data.mod_settings.NextSurfacingDo_next.listAction = []
            //@ts-ignore
            if (typeof irisConfig.data.mod_settings.NextSurfacingDo_next.listAction === 'string')
              irisConfig.data.mod_settings.NextSurfacingDo_next.listAction = [
                irisConfig.data.mod_settings.NextSurfacingDo_next.listAction,
              ]

            context.commit(types.GLIDER_IRIS_NSD_SAVE_SUCCESS, { id: itemId, nsdConfig: irisConfig.data })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_NSD_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_NSD_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_FILE_TRANSFERT_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_REQUEST)
      apiGlider
        .getFileTransfertConfig(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModFileTransfer
            context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SUCCESS, {
              id: itemId,
              fileTransfertConfig: irisConfig.data,
            })
            patchRuntimeModuleEnable(context, 'FileTransfer', irisConfig.data, itemId)
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_UPDATE_MODIFIED_FILE_TRANSFERT](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, newProperties }: { itemId: number; newProperties: Object },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_UPDATE_MODIFIED_FILE_TRANSFERT, { itemId, newProperties })
      resolve(context.state.modifiedFileTransfertConfigs[itemId])
    })
  }

  public [types.GLIDER_CANCEL_MODIFIED_FILE_TRANSFERT](
    context: ActionContext<IGliderState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_CANCEL_MODIFIED_FILE_TRANSFERT, itemId)
      resolve(context.state.modifiedFileTransfertConfigs[itemId])
    })
  }

  public [types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_REQUEST)
      apiGlider
        .saveFileTransfertConfig(itemId, context.state.modifiedFileTransfertConfigs[itemId])
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModFileTransfer
            context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_SUCCESS, {
              id: itemId,
              fileTransfertConfig: irisConfig.data,
            })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_FILE_TRANSFERT_ENABLE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, enable }: { itemId: number; enable: boolean },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_REQUEST)
      apiGlider
        .enableFileTransfertModule(itemId, enable)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModFileTransfer
            context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_SUCCESS, {
              id: itemId,
              fileTransfertConfig: irisConfig.data,
            })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST)
      apiGlider
        .getSingleWayPointConfig(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModSingleWayPoint
            context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SUCCESS, {
              id: itemId,
              singleWayPointConfig: irisConfig.data,
            })
            patchRuntimeModuleEnable(context, 'SingleWayPoint', irisConfig.data, itemId)
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_ERROR)
            const error = resp.data.data as AloError
            console.error(error.errorMessage)
            reject(error)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_UPDATE_MODIFIED_SINGLE_WAY_POINT](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, newProperties }: { itemId: number; newProperties: Object },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_UPDATE_MODIFIED_SINGLE_WAY_POINT, { itemId, newProperties })
      resolve(context.state.modifiedSingleWayPointConfigs[itemId])
    })
  }

  public [types.GLIDER_CANCEL_MODIFIED_SINGLE_WAY_POINT](
    context: ActionContext<IGliderState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_CANCEL_MODIFIED_SINGLE_WAY_POINT, itemId)
      resolve(context.state.modifiedSingleWayPointConfigs[itemId])
    })
  }

  public [types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_REQUEST)
      apiGlider
        .saveSingleWayPointConfig(itemId, context.state.modifiedSingleWayPointConfigs[itemId])
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModSingleWayPoint
            context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_SUCCESS, {
              id: itemId,
              singleWayPointConfig: irisConfig.data,
            })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_SINGLE_WAY_POINT_ENABLE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, enable }: { itemId: number; enable: boolean },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_REQUEST)
      apiGlider
        .enableSingleWayPointModule(itemId, enable)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModSingleWayPoint
            context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_SUCCESS, {
              id: itemId,
              singleWayPointConfig: irisConfig.data,
            })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_FTP_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_FTP_REQUEST)
      apiGlider
        .getFtpConfig(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModFtp
            context.commit(types.GLIDER_IRIS_FTP_SUCCESS, { id: itemId, ftpConfig: irisConfig.data })
            patchRuntimeModuleEnable(context, 'FTP', irisConfig.data, itemId)
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_FTP_ERROR)
            const error = resp.data.data as AloError
            console.error(error.errorMessage)
            reject(error)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_FTP_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_UPDATE_MODIFIED_FTP](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, newProperties }: { itemId: number; newProperties: Object },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_UPDATE_MODIFIED_FTP, { itemId, newProperties })
      resolve(context.state.modifiedFtpConfigs[itemId])
    })
  }

  public [types.GLIDER_CANCEL_MODIFIED_FTP](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_CANCEL_MODIFIED_FTP, itemId)
      resolve(context.state.modifiedFtpConfigs[itemId])
    })
  }

  public [types.GLIDER_IRIS_FTP_SAVE_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_FTP_SAVE_REQUEST)
      apiGlider
        .saveFtpConfig(itemId, context.state.modifiedFtpConfigs[itemId])
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModFtp
            context.commit(types.GLIDER_IRIS_FTP_SAVE_SUCCESS, { id: itemId, ftpConfig: irisConfig.data })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_FTP_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_FTP_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_FTP_ENABLE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, enable }: { itemId: number; enable: boolean },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_FTP_SAVE_REQUEST)
      apiGlider
        .enableFtpModule(itemId, enable)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModFtp
            context.commit(types.GLIDER_IRIS_FTP_SAVE_SUCCESS, { id: itemId, ftpConfig: irisConfig.data })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_FTP_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_FTP_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_RSYNC_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_RSYNC_REQUEST)
      apiGlider
        .getRsyncConfig(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModRsync
            context.commit(types.GLIDER_IRIS_RSYNC_SUCCESS, { id: itemId, rsyncConfig: irisConfig.data })
            patchRuntimeModuleEnable(context, 'RSync', irisConfig.data, itemId)
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_RSYNC_ERROR)
            const error = resp.data.data as AloError
            console.error(error.errorMessage)
            reject(error)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_RSYNC_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_UPDATE_MODIFIED_RSYNC](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, newProperties }: { itemId: number; newProperties: Object },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_UPDATE_MODIFIED_RSYNC, { itemId, newProperties })
      resolve(context.state.modifiedRsyncConfigs[itemId])
    })
  }

  public [types.GLIDER_CANCEL_MODIFIED_RSYNC](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_CANCEL_MODIFIED_RSYNC, itemId)
      resolve(context.state.modifiedRsyncConfigs[itemId])
    })
  }

  public [types.GLIDER_IRIS_RSYNC_SAVE_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_RSYNC_SAVE_REQUEST)
      apiGlider
        .saveRsyncConfig(itemId, context.state.modifiedRsyncConfigs[itemId])
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModRsync
            context.commit(types.GLIDER_IRIS_RSYNC_SAVE_SUCCESS, { id: itemId, rsyncConfig: irisConfig.data })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_RSYNC_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_RSYNC_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_RSYNC_ENABLE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, enable }: { itemId: number; enable: boolean },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_RSYNC_SAVE_REQUEST)
      apiGlider
        .enableRsyncModule(itemId, enable)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModRsync
            context.commit(types.GLIDER_IRIS_RSYNC_SAVE_SUCCESS, { id: itemId, rsyncConfig: irisConfig.data })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_RSYNC_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_RSYNC_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_EXPECTED_NMEA_REQUEST](context: ActionContext<IGliderState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_REQUEST)
      apiGlider
        .getExpectedNMEAConfig(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModExpectedNMEA
            context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SUCCESS, { id: itemId, expectedNMEAConfig: irisConfig.data })
            patchRuntimeModuleEnable(context, 'ExpectedNMEA', irisConfig.data, itemId)
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_ERROR)
            const error = resp.data.data as AloError
            console.error(error.errorMessage)
            reject(error)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_UPDATE_MODIFIED_EXPECTED_NMEA](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, newProperties }: { itemId: number; newProperties: Object },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_UPDATE_MODIFIED_EXPECTED_NMEA, { itemId, newProperties })
      resolve(context.state.modifiedExpectedNMEAConfigs[itemId])
    })
  }

  public [types.GLIDER_CANCEL_MODIFIED_EXPECTED_NMEA](
    context: ActionContext<IGliderState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_CANCEL_MODIFIED_EXPECTED_NMEA, itemId)
      resolve(context.state.modifiedExpectedNMEAConfigs[itemId])
    })
  }

  public [types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_REQUEST)
      apiGlider
        .saveExpectedNMEAConfig(itemId, context.state.modifiedExpectedNMEAConfigs[itemId])
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModExpectedNMEA
            context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_SUCCESS, {
              id: itemId,
              expectedNMEAConfig: irisConfig.data,
            })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_IRIS_EXPECTED_NMEA_ENABLE_REQUEST](
    context: ActionContext<IGliderState, IRootState>,
    { itemId, enable }: { itemId: number; enable: boolean },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_REQUEST)
      apiGlider
        .enableExpectedNMEAModule(itemId, enable)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const irisConfig = resp.data.data as IrisrawModExpectedNMEA
            context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_SUCCESS, {
              id: itemId,
              expectedNMEAConfig: irisConfig.data,
            })
            resolve(irisConfig.data)
          } else {
            context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_ERROR)
          reject()
        })
    })
  }

  public [types.GLIDER_MODCONF_UPDATE](context: ActionContext<IGliderState, IRootState>, wobMessage: WobGliderModConf) {
    return new Promise((resolve, reject) => {
      switch (wobMessage.modKey) {
        case 'ExpectedNMEA': {
          if (context.getters.originalExpectedNMEAConfigs[wobMessage.gliId]) {
            //on utilise la reponse transmise par le wob
            const expectedNMEAConfig = wobMessage.modIrisConf as IrisConfigContainer<IExpectedNMEAConfig>
            context.commit(types.GLIDER_IRIS_EXPECTED_NMEA_SUCCESS, { id: wobMessage.gliId, expectedNMEAConfig })
            patchRuntimeModuleEnable(context, 'ExpectedNMEA', expectedNMEAConfig, wobMessage.gliId)
            resolve(expectedNMEAConfig)
          }
          break
        }
        case 'FileTransfer': {
          if (context.getters.originalFileTransfertConfigs[wobMessage.gliId]) {
            //on utilise la reponse transmise par le wob
            const fileTransfertConfig = wobMessage.modIrisConf as IrisConfigContainer<IFileTransfertConfig>
            context.commit(types.GLIDER_IRIS_FILE_TRANSFERT_SUCCESS, { id: wobMessage.gliId, fileTransfertConfig })
            patchRuntimeModuleEnable(context, 'FileTransfer', fileTransfertConfig, wobMessage.gliId)
            resolve(fileTransfertConfig)
          }
          break
        }
        case 'NextSurfacingDo': {
          if (context.getters.originalNsdConfigs[wobMessage.gliId]) {
            //on utilise la reponse transmise par le wob
            const nsdConfig = wobMessage.modIrisConf as IrisConfigContainer<INextSurfacingDoConfig>
            //@ts-ignore
            if (nsdConfig.mod_settings.NextSurfacingDo_all.listAction == '')
              nsdConfig.mod_settings.NextSurfacingDo_all.listAction = []
            //@ts-ignore
            if (typeof nsdConfig.mod_settings.NextSurfacingDo_all.listAction === 'string')
              nsdConfig.mod_settings.NextSurfacingDo_all.listAction = [
                nsdConfig.mod_settings.NextSurfacingDo_all.listAction,
              ]
            //@ts-ignore
            if (nsdConfig.mod_settings.NextSurfacingDo_next.listAction == '')
              nsdConfig.mod_settings.NextSurfacingDo_next.listAction = []
            //@ts-ignore
            if (typeof nsdConfig.mod_settings.NextSurfacingDo_next.listAction === 'string')
              nsdConfig.mod_settings.NextSurfacingDo_next.listAction = [
                nsdConfig.mod_settings.NextSurfacingDo_next.listAction,
              ]
            context.commit(types.GLIDER_IRIS_NSD_SUCCESS, { id: wobMessage.gliId, nsdConfig })
            patchRuntimeModuleEnable(context, 'NextSurfacingDo', nsdConfig, wobMessage.gliId)
            resolve(nsdConfig)
          }
          break
        }
        case 'SingleWayPoint': {
          if (context.getters.originalSingleWayPointConfigs[wobMessage.gliId]) {
            //on utilise la reponse transmise par le wob
            const singleWayPointConfig = wobMessage.modIrisConf as IrisConfigContainer<ISingleWayPointConfig>
            context.commit(types.GLIDER_IRIS_SINGLE_WAY_POINT_SUCCESS, { id: wobMessage.gliId, singleWayPointConfig })
            patchRuntimeModuleEnable(context, 'SingleWayPoint', singleWayPointConfig, wobMessage.gliId)
            resolve(singleWayPointConfig)
          }
          break
        }
        case 'SendMail': {
          if (context.rootGetters.originalSendMailConfigs[wobMessage.misId]) {
            //on utilise la reponse transmise par le wob
            const sendMailConfig = wobMessage.modIrisConf as IrisConfigContainer<ISendMailConfig>
            context.commit(types.MISSION_IRIS_SEND_MAIL_SUCCESS, { id: wobMessage.misId, sendMailConfig })
            patchRuntimeModuleEnable(
              context,
              'SendMail',
              sendMailConfig,
              (context.rootGetters.missionsById[wobMessage.misId] as AloMission | undefined)?.gliId,
            )
            resolve(sendMailConfig)
          }
          break
        }
        case 'FTP': {
          if (context.getters.originalFtpConfigs[wobMessage.gliId]) {
            //on utilise la reponse transmise par le wob
            const ftpConfig = wobMessage.modIrisConf as IrisConfigContainer<IFtpConfig>
            context.commit(types.GLIDER_IRIS_FTP_SUCCESS, { id: wobMessage.gliId, ftpConfig })
            patchRuntimeModuleEnable(context, 'FTP', ftpConfig, wobMessage.gliId)
            resolve(ftpConfig)
          }
          break
        }
        case 'RSync': {
          if (context.getters.originalRsyncConfigs[wobMessage.gliId]) {
            //on utilise la reponse transmise par le wob
            const rsyncConfig = wobMessage.modIrisConf as IrisConfigContainer<IRsyncConfig>
            context.commit(types.GLIDER_IRIS_RSYNC_SUCCESS, { id: wobMessage.gliId, rsyncConfig })
            patchRuntimeModuleEnable(context, 'RSync', rsyncConfig, wobMessage.gliId)
            resolve(rsyncConfig)
          }
          break
        }
        case 'Coriolis': {
          if (context.rootGetters.originalCoriolisConfigs[wobMessage.misId]) {
            //on utilise la reponse transmise par le wob
            const coriolisConfig = wobMessage.modIrisConf as IrisConfigContainer<ICoriolisConfig>
            context.commit(types.MISSION_IRIS_CORIOLIS_SUCCESS, { id: wobMessage.misId, coriolisConfig })
            patchRuntimeModuleEnable(
              context,
              'Coriolis',
              coriolisConfig,
              (context.rootGetters.missionsById[wobMessage.misId] as AloMission | undefined)?.gliId,
            )
            resolve(coriolisConfig)
          }
          break
        }
        case 'MissionPlan': {
          if (context.rootGetters.originalMissionPlanConfigs[wobMessage.misId]) {
            //on utilise la reponse transmise par le wob
            const missionPlanConfig = wobMessage.modIrisConf as IrisConfigContainer<IMissionPlanConfig>
            context.commit(types.MISSION_IRIS_MISSION_PLAN_CONFIG_SUCCESS, { id: wobMessage.misId, missionPlanConfig })
            patchRuntimeModuleEnable(
              context,
              'MissionPlan',
              missionPlanConfig,
              (context.rootGetters.missionsById[wobMessage.misId] as AloMission | undefined)?.gliId,
            )
            resolve(missionPlanConfig)
          }
          break
        }
        case 'AD2CP': {
          if (context.rootGetters.originalAd2cpConfigs[wobMessage.misId]) {
            //on utilise la reponse transmise par le wob
            const ad2cpConfig = wobMessage.modIrisConf as IrisConfigContainer<IAd2cpConfig>
            context.commit(types.MISSION_IRIS_AD2CP_SUCCESS, { id: wobMessage.misId, ad2cpConfig })
            patchRuntimeModuleEnable(
              context,
              'AD2CP',
              ad2cpConfig,
              (context.rootGetters.missionsById[wobMessage.misId] as AloMission | undefined)?.gliId,
            )
            if (ad2cpConfig.mod_settings.AD2CP_state.current_state != 'READY') {
              const mission = context.rootGetters.missionsById[wobMessage.misId] as AloMission
              if (mission) mission.ad2cpDataIntegrationState = 'Pilot.Ad2cp.DtiWaiting'
            }
            resolve(ad2cpConfig)
          }
          break
        }
        case 'QuickControl': {
          // QuickControl est mutuellement exclusif avec MissionPlan/SingleWayPoint :
          // activer l'un de ceux-ci désactive QuickControl côté backend, qui pousse
          // alors ce modconf. Sans ce case, le message tombait en `default` →
          // `gliderRuntime.modules.QuickControl` + `modifiedQuickControlConfigs[misId]`
          // restaient périmés tant que l'onglet QuickControl était déjà monté
          // (il ne re-fetch qu'au `mounted()`). Config indexée par mission (misId).
          if (context.rootGetters.originalQuickControlConfigs[wobMessage.misId]) {
            const quickControlConfig = wobMessage.modIrisConf as IrisConfigContainer<IQuickControlConfig>
            context.commit(types.MISSION_IRIS_QUICKCONTROL_CONFIG_SUCCESS, {
              id: wobMessage.misId,
              config: quickControlConfig,
            })
            patchRuntimeModuleEnable(
              context,
              'QuickControl',
              quickControlConfig,
              (context.rootGetters.missionsById[wobMessage.misId] as AloMission | undefined)?.gliId,
            )
            resolve(quickControlConfig)
          }
          break
        }
        case 'AIS': {
          // Anticollision : sans ce case, activer ou couper le module ne changeait rien à l'écran
          // avant rechargement. Config indexée par mission (misId) ; l'état activé du module est
          // reporté dans le runtime des missions du planeur (icône AIS de MissionState, BK-098).
          const aisConfig = wobMessage.modIrisConf as IrisConfigContainer<IAisConfig>
          if (context.rootGetters.originalAisConfigs[wobMessage.misId]) {
            context.commit(types.MISSION_IRIS_AIS_SUCCESS, { id: wobMessage.misId, aisConfig })
          }
          patchRuntimeModuleEnable(
            context,
            'AIS',
            aisConfig,
            wobMessage.gliId ?? (context.rootGetters.missionsById[wobMessage.misId] as AloMission | undefined)?.gliId,
          )
          resolve(aisConfig)
          break
        }
        default: {
          resolve(false)
          break
        }
      }
    })
  }
}

export default util.classToObject(GliderAction)
